import { jsx } from 'react/jsx-runtime';

const SvgNavFolder = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M4 5h5.86l1.67 2H20v12H2v2h20V5h-9.53l-1.68-2H2v14h2V5Z" }) }));

export { SvgNavFolder as default };
//# sourceMappingURL=NavFolder.es.js.map
